import { CRF_LOGS_ENDPOINT } from '../endpoints/'
import getRequest from '../request/getRequest'

export default async ({ crfNo }) => {
  try {
    const response = await getRequest({
      url: `${CRF_LOGS_ENDPOINT}/${crfNo}`
    })
    const { data } = response.data
    const status = response.status
    return { status, response: data }
  } catch (error) {
    const { Error } = error.response.data
    const status = error.response.status
    return { status, response: Error }
  }
}
